import styled from 'styled-components';

export const OL = styled.ol``

export const LI = styled.li``
